(function ($, Promise) {

		var FEEDBACK_SUCCESS = 6;
		var FEEDBACK_FAILURE = 7;

		var DELAY_CURRENT_EVENT_REMAINING_TIME = 3;
		var DELAY_CURRENT_EVENT_REMAINING_TIME_WITH_MAXIMUM = 5;
		var DELAY_DEFAULT = 4;

		// Setup the prototype inheritance
		extend(BaseGameLYVLC, TrackingAirplanes);

		// Constructor
		function TrackingAirplanes() {

			// Super constructor
			BaseGameLYVLC.call(this, "data/tracking-airplanes.json");
			this.screensaverDelay = 32;

			// Override initial screen language flip interval
			this.initalScreenIntervalDuration = 6000;

			this.playlist = new AudioPlaylist();
			this.columns = 'ABCDEFGHIJ'.split('');
			this.rows = '1,2,3,4,5,6,7,8,9,10'.split(',');
			this.maximumErrors = 3;

			this.$slotModel = false;
			this.$grid = false;

			this.instructionsSwiper = false;

			this.errorsCount = 0;
			this.selectedAirplane = false;
			this.currentGameId = -1;
			this.currentEvent = false;
			this.currentEventData = false;
			this.currentFeedback = false;
			this.totalEvents = false;

			this.currentEventStartTime = false;
			this.validateTimeout = false;
			this.nextLevelEventTimeout = false;
			this.redirectTimeout = false;

			// Remove out of screen element to avoid light pollution using a CSS class
			if (inElectron()) {
				$("#main").addClass("in-electron")
			}
		}

		// To be overriden in child games
		TrackingAirplanes.prototype.buildContent = function () {
			return new Promise($.proxy(function (resolve, reject) {

				// Create instructions slides
				this.instructionsSwiper = new Swiper('#instructions', {
					speed: 400,
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets',
					},
				});

				// Handle instructions videos play/pause
				this.instructionsSwiper.on("slideChangeTransitionStart", $.proxy(function () {
					this.stopInstructionVideos(this.instructionsSwiper);
				}, this));
				this.instructionsSwiper.on("touchStart", $.proxy(function () {
					this.stopInstructionVideos();
				}, this));
				this.instructionsSwiper.on("transitionEnd", $.proxy(function () {
					this.startInstructionVideo(this.instructionsSwiper.activeIndex);
				}, this));

				$(".button-prev").on(this.touchEvent, $.proxy(function () {
					this.instructionsSwiper.slidePrev();
					this.initScreenAudio(2);
				}, this))

				$(".button-next, .button-enter").on(this.touchEvent, $.proxy(function () {
					if (this.instructionsSwiper.activeIndex >= (this.instructionsSwiper.slides.length - 1)) {
						this.goToScreen(3);
					} else {
						this.instructionsSwiper.slideNext();
						this.initScreenAudio(2);
					}
				}, this))

				// Save and remove models
				this.$slotModel = $("#screen-3 .slot.model").remove().removeClass("model");
				this.$grid = $("#screen-3 #grid");

				// Create grid
				for (var i = 0; i < this.rows.length; i++) {
					var $row = $("<div class='row'></div>");
					for (var j = 0; j < this.columns.length; j++) {
						var $item = this.$slotModel.clone();
						$item.attr("id", "slot-" + this.columns[j] + this.rows[i]);
						$item.data("slot-id", this.columns[j] + this.rows[i]);
						$row.append($item);
					}
					this.$grid.append($row);
				}

				// Grid click listener
				this.$grid.find(".slot").on(this.touchEvent, $.proxy(this.clickSlot, this));

				// Preload audio
				var allAudioFiles = this.findAllAudioFiles(this.data);
				this.audio.preload(allAudioFiles)

				// Make sure rimeder overlay is hidden
				this.closeReminderModal();

				resolve();

			}, this));
		}

		// To be overriden in child games
		TrackingAirplanes.prototype.initGame = function () {
			console.log("init game");

			// Go to first screen
			if (inElectron()) {
				this.initScreenSaver();
				this.goToScreen(1);
			} else {
				$("#first-click-interact").one(this.touchEvent, $.proxy(this.initScreenSaver, this));
				this.goToScreen("first-click-interact");
			}

			// this.goToScreen(3);

			// setTimeout($.proxy(function () {
			// 	this.triggerReminderModal($.proxy(function () {
			// 		this.levelEvent(this.currentEvent)
			// 	}, this));
			// }, this), 300);

			// this.currentFeedback = FEEDBACK_FAILURE;
			// this.currentFeedback = FEEDBACK_SUCCESS;
			// this.goToScreen(4);

			// Close still there on touch screen
			$(document).on(this.touchEvent, $.proxy(function () {
				this.closeStillThereModal();
			}, this));
		};

		// To be overriden in child games
		TrackingAirplanes.prototype.initScreen = function (screenId) {

			// Super constructor
			if (BaseGameLYVLC.prototype.initScreen.call(this, screenId) == false) {
				return false;
			}

			switch (screenId) {
				case 1:
					this.reset();
					break;
				case 2:
					this.instructionsSwiper.slideTo(0, 0);
					this.startInstructionVideo(0);
					break;
				case 3:
					this.stopAllInstructionVideos();
					this.reset();
					this.currentGameId = (this.currentGameId + 1) % this.data.games.length;
					this.startLevel(this.currentGameId);
					break;
				case 4:
					$("#screen-4 #feedback-success").toggle(this.currentFeedback == FEEDBACK_SUCCESS)
					$("#screen-4 #feedback-failure").toggle(this.currentFeedback == FEEDBACK_FAILURE)

					break;
			}

			this.initScreenAudio(screenId);
		}

		// To be overriden in child games
		TrackingAirplanes.prototype.initScreenAudio = function (screenId) {

			switch (screenId) {
				case 1:
					this.playlist.clear();
					// this.playlist.add(this.data.content.initial_screen.audio_repeat, true, 2000);
					this.playlist.add(this.data.content.initial_screen.audio[this.i18n.lang], false);
					this.playlist.add(this.data.content.initial_screen.audio_repeat[this.i18n.lang], true, 5000);
					this.playlist.play();
					break;
				case 2:
					this.playlist.clear();
					var currentInstrucion = "instruction" + (this.instructionsSwiper.activeIndex + 1);
					if (this.data.content[currentInstrucion].audio) {
						this.playlist.add(this.data.content[currentInstrucion].audio[this.i18n.lang], false, false, false, true);
					}
					if (this.data.content[currentInstrucion].audio_repeat) {
						this.playlist.add(this.data.content[currentInstrucion].audio_repeat[this.i18n.lang], true, 5000);
					}
					this.playlist.play();
					break;
				case 3:
					break;
				case 4:
					this.playlist.clear();
					if (this.currentFeedback == FEEDBACK_SUCCESS) {
						this.playlist.add(this.data.content.feedback_final_success.audio[this.i18n.lang]);
					} else if (this.currentFeedback == FEEDBACK_FAILURE) {
						this.playlist.add(this.data.content.feedback_final_failure.audio[this.i18n.lang]);
					}

					// Handle redirect timer
					if (this.redirectTimeout != false) {
						clearTimeout(this.redirectTimeout)
						this.redirectTimeout = false;
					}
					this.redirectTimeout = setTimeout($.proxy(function () {
						this.goToScreen(1);
					}, this), 14500);

					this.playlist.play();
					break;
			}
		}

		// To be overriden in child games
		TrackingAirplanes.prototype.closeStillThereModal = function () {

			if (this.stillThereTimeout != false) {
				console.log("!!! closeStillThereModal", this.currentScreen, this.nextLevelEventTimeout)
				if (this.currentScreen == 3) {
					this.playlist.clear();
					this.scheduleNextLevelEvent(DELAY_DEFAULT);
				} else {
					this.initScreenAudio(this.currentScreen);
				}
			}

			// Super
			BaseGameLYVLC.prototype.closeStillThereModal.call(this);
		}

		// To be overriden in child games
		TrackingAirplanes.prototype.onMessage = function (e) {
			var message = e.message;
			console.log("message received : ", message);

			// Reset still there interval
			this.resetTimer();

			if (this.lockScreen) {
				return;
			}

			if (this.stillThereTimeout != false) {
				this.closeStillThereModal();
				return;
			}

			// Global buttons
			switch (this.currentScreen) {
				case 1:
					if (message == this.buttons["english"]) {
						// English button
						this.playlist.clear();
						this.requestedLanguage = "en";
						this.goToScreen(2);
					} else if (message == this.buttons["french"]) {
						// French button
						this.playlist.clear()
						this.requestedLanguage = "fr";
						this.goToScreen(2);
					} else if (message == this.buttons["home"]) {
						// Home button
					}
					break;
				case 3:
					if (message == this.buttons["english"]) {
						// English button
						// this.playlist.clear();
						this.i18n.setWithFlip("en");
						// this.goToScreen(4);
					} else if (message == this.buttons["french"]) {
						// French button
						// this.playlist.clear();
						this.i18n.setWithFlip("fr");
						// this.goToScreen(4);
					} else if (message == this.buttons["home"]) {
						// Home button
						this.clearAllTimeouts();
						this.playlist.clear();
						this.goToScreen(1);
					}
					break;
				default:
					if (message == this.buttons["english"]) {
						// English button
						this.i18n.setWithFlip("en");
						this.initScreen(this.currentScreen);
					} else if (message == this.buttons["french"]) {
						// French button
						this.i18n.setWithFlip("fr");
						this.initScreen(this.currentScreen);
					} else if (message == this.buttons["home"]) {
						// Home button
						this.playlist.clear();
						this.goToScreen(1);
					}
					break;
			}


			// Airplanes and select butttons
			switch (this.currentScreen) {
				case 1:
					break;
				case 2:
					if (message == this.buttons["select"] || message == this.buttons["right"]) {
						// SELECT OR NEXT
						if (this.instructionsSwiper.activeIndex >= (this.instructionsSwiper.slides.length - 1)) {
							this.playlist.clear();
							this.goToScreen(3);
						} else {
							this.instructionsSwiper.slideNext();
							this.initScreenAudio(2);
						}
					} else if (message == this.buttons["left"]) {
						// LEFT
						this.instructionsSwiper.slidePrev();
						this.initScreenAudio(2);
					}
					break;
				case 3:
					if (message == this.buttons["airplane_blue"]) {
						// Blue airplane button
						this.selectedAirplane = 'blue';
					} else if (message == this.buttons["airplane_red"]) {
						// Red airplane button
						this.selectedAirplane = 'red';
					} else if (message == this.buttons["airplane_green"]) {
						// Green airplane button
						this.selectedAirplane = 'green';
					} else if (message == this.buttons["warning"]) {
						// WARNING
						this.clickWarning();
					}
					break;
			}
		}

		TrackingAirplanes.prototype.startLevel = function (levelId) {
			this.errorsCount = 0;
			this.currentGameId = levelId;
			this.currentEvent = 0
			this.totalEvents = this.data.games[this.currentGameId].events.length;
			this.levelEvent(0)
		}

		TrackingAirplanes.prototype.scheduleNextLevelEvent = function (delayMode) {

			// Define delay to use
			var delay = this.getScheduleEventDelay(delayMode);
			console.log("scheduleNextLevelEvent in " + (delay / 1000).toFixed(2) + " seconds.")

			// Clear current timeout, if any
			if (this.nextLevelEventTimeout != false) {
				clearTimeout(this.nextLevelEventTimeout)
				this.nextLevelEventTimeout = false;
			}

			// Timeout
			this.nextLevelEventTimeout = setTimeout($.proxy(function () {
				var nextEventID = this.currentEvent + 1;

				if (nextEventID >= this.totalEvents) {
					// Level completed : go to screen 4 and show feedback
					this.currentFeedback = FEEDBACK_SUCCESS;
					this.goToScreen(4);
				} else {
					this.levelEvent(nextEventID)
				}
			}, this), delay);
		}

		TrackingAirplanes.prototype.levelEvent = function (eventId) {
			this.currentEvent = eventId;
			this.currentEventData = this.data.games[this.currentGameId].events[eventId];

			console.log("levelEvent", this.currentEvent, this.currentEventData)

			this.clearValidateTimeout();
			this.currentEventStartTime = false;

			this.playlist.clear();
			this.playlist.add(this.currentEventData.audio[this.i18n.lang], false, false, $.proxy(function () {
				this.currentEventStartTime = millis();
				this.addEventValidation(this.currentEventData);
			}, this));
			this.playlist.play();

			this.currentEvent = eventId;
		}

		TrackingAirplanes.prototype.addEventValidation = function (eventData) {

			// This is the full event duration, since this.currentEventStartTime has just been set
			var delay = this.getScheduleEventDelay(DELAY_CURRENT_EVENT_REMAINING_TIME);

			// Validate response timeout
			console.log("addEventValidation in " + (delay / 1000).toFixed(2) + " seconds.")

			if (eventData.type == "moving" || eventData.type == "exit") {
				// Moving
				this.validateTimeout = setTimeout($.proxy(function () {
					this.errorsCount++;
					this.clearValidateTimeout();
					this.incorrectAction("feedback_missed" + this.errorsCount);
				}, this), delay);

			} else if (eventData.type == "warning") {

				// Warning
				this.validateTimeout = setTimeout($.proxy(function () {
					this.clearValidateTimeout();
					this.markSlot($("#slot-" + this.currentEventData.position_redirect), [this.currentEventData.plane]);

					this.playlist.clear();
					this.playlist.add(this.currentEventData.audio_missed[this.i18n.lang], false, false, $.proxy(function () {
						this.scheduleNextLevelEvent(DELAY_DEFAULT);
					}, this));
					this.playlist.play();
				}, this), 3000);

			}
		}

		TrackingAirplanes.prototype.getScheduleEventDelay = function (mode) {
			if (mode == DELAY_CURRENT_EVENT_REMAINING_TIME || mode == DELAY_CURRENT_EVENT_REMAINING_TIME_WITH_MAXIMUM) {
				var currentProgess = (this.currentEvent) / this.totalEvents;
				var fullDelay = map(currentProgess, 0, 1, 8000, 2500);
				var delay = fullDelay;

				if (this.currentEventStartTime !== false) {
					delay = fullDelay - (millis() - this.currentEventStartTime);
				}

				// Apply maximum delay (used after user interaction
				if (mode == DELAY_CURRENT_EVENT_REMAINING_TIME_WITH_MAXIMUM) {
					delay = (Math.min(delay, 3000))
				}

				return delay;

			} else {
				return 500;
			}
		}

		TrackingAirplanes.prototype.clickSlot = function (e) {

			this.resetTimer();

			// Skip touch event if there is no current event.
			if (this.currentEventData == false) {
				return;
			}

			// Skip touch event if thi is not a move event
			if (this.currentEventData.type == "warning") {
				return;
			}

			if (this.selectedAirplane != false) {

				var $slot = $(e.currentTarget);
				var selectedSlot = $(e.currentTarget).data("slot-id");

				if (this.selectedAirplane == this.currentEventData.plane && selectedSlot == this.currentEventData.position) {
					// Right answer
					console.log("Right answer");
					this.clearValidateTimeout();
					this.markSlot($slot, [this.selectedAirplane]);
					this.scheduleNextLevelEvent(DELAY_CURRENT_EVENT_REMAINING_TIME_WITH_MAXIMUM);

				} else {
					// Wrong answer
					console.log("wrong answer");
					this.errorsCount++;
					this.clearValidateTimeout();
					this.markSlot($slot, ["error"]);
					this.incorrectAction("feedback_missed" + this.errorsCount);
				}

				this.selectedAirplane = false;
				this.currentEventData = false;

			} else {
				console.log("show reminder (select airplane first)")
				this.clearValidateTimeout();
				this.triggerReminderModal($.proxy(function () {
					this.levelEvent(this.currentEvent)
				}, this));
			}
		}

		TrackingAirplanes.prototype.clickWarning = function () {

			this.resetTimer();

			// Skip touch event if there is no current event.
			if (this.currentEventData == false) {
				return;
			}

			if (this.currentEventData.type == "warning") {
				// Waring button was required
				console.log("Warning button pushed, as needed");

				this.clearValidateTimeout();

				this.playlist.clear();
				this.playlist.add(this.currentEventData.audio_caught[this.i18n.lang], false, false, $.proxy(function () {
					this.scheduleNextLevelEvent(DELAY_CURRENT_EVENT_REMAINING_TIME);
				}, this));
				this.playlist.play();

				// Mark correct slot with correct answer
				this.markSlot($("#slot-" + this.currentEventData.position_redirect), [this.currentEventData.plane]);

			} else {
				// Wrong button was a wrong answer
				console.log("Warning button pushed, but this was NOT needed, error.");
				this.errorsCount++;
				this.clearValidateTimeout();

				if (this.errorsCount < this.maximumErrors) {

					// Play error message specific to warning button
					this.incorrectAction("feedback_warning_error")

				} else {

					// We reched maximum errorcount, use default infforec action behaviour
					this.incorrectAction("feedback_missed3")
				}
			}
		}

		TrackingAirplanes.prototype.incorrectAction = function (feedback_audio_id) {

			console.log("Incorrect action (" + this.errorsCount + "), playing feedback " + feedback_audio_id);

			this.playlist.clear();
			this.playlist.add(this.data.content[feedback_audio_id].audio[this.i18n.lang], false, false, $.proxy(function () {
				if (this.errorsCount < this.maximumErrors) {
					console.log("this.scheduleNextLevelEvent(DELAY_DEFAULT);")
					this.scheduleNextLevelEvent(DELAY_DEFAULT);
				} else {
					// Maximum errrors reached : go to screeen 6 with negative feedback
					console.log("maximum errrors reached, negative feedback");
					this.currentFeedback = FEEDBACK_FAILURE;
					this.goToScreen(4);
				}
			}, this));
			this.playlist.play();

			this.nextLevelEventTimeout = setTimeout($.proxy(function (missedEvent) {
				console.log("Supervisor fixes it.", missedEvent.position, missedEvent.plane, this.currentEventData)
				this.markSlot($("#slot-" + missedEvent.position), [missedEvent.plane]);
			}, this, this.currentEventData), 1500);

			this.currentEventStartTime = false;
			this.currentEventData = false;
		}

		TrackingAirplanes.prototype.markSlot = function ($slot, classes) {
			$("#grid .slot." + classes[0]).addClass("previous");
			$slot.removeClass("empty error blue red green previous").addClass(classes);
		}

		TrackingAirplanes.prototype.startInstructionVideo = function (slideIndex) {
			var slides = $(this.instructionsSwiper.el).find(".swiper-slide");
			slides.each(function (i, n) {
				$(n).find("video").each(function (i2, n2) {
					if (i == slideIndex) {
						n2.play();
					} else {
						n2.currentTime = 0;
						n2.pause();
					}
				});
			});
		}

		TrackingAirplanes.prototype.stopInstructionVideos = function () {
			var slides = $(this.instructionsSwiper.el).find(".swiper-slide");
			slides.each(function (i, n) {
				$(n).find("video").each(function (i2, n2) {
					n2.pause();
				});
			});
		}

		TrackingAirplanes.prototype.stopAllInstructionVideos = function () {
			var videos = $(this.instructionsSwiper.el).find("video");
			videos.each(function (i, n) {
				n.pause();
			});
		}

		TrackingAirplanes.prototype.clearValidateTimeout = function () {
			if (this.validateTimeout != false) {
				clearTimeout(this.validateTimeout)
				this.validateTimeout = false;
			}
		}

		TrackingAirplanes.prototype.clearAllTimeouts = function () {

			if (this.redirectTimeout != false) {
				clearTimeout(this.redirectTimeout);
				this.redirectTimeout = false;
			}

			if (this.validateTimeout != false) {
				clearTimeout(this.validateTimeout);
				this.validateTimeout = false;
			}

			if (this.nextLevelEventTimeout != false) {
				clearTimeout(this.nextLevelEventTimeout);
				this.nextLevelEventTimeout = false;
			}
		}

		TrackingAirplanes.prototype.triggerReminderModal = function (callback) {

			// Send serial message so ardunio can blink leds when no plane is selected (2021-03-026)
			this.serial.write("no_airplane_selected_flash_led\n")

			var tl = new TimelineMax();
			tl.to($("#reminder"), 0.5, {
				autoAlpha: 1
			});
			tl.fromTo($("#reminder .modal"), 0.5, {
				autoAlpha: 0,
				y: "-10px",
			}, {
				autoAlpha: 1,
				y: 0,
			});

			this.playlist.clear();
			this.playlist.add(this.data.content.reminder.audio[this.i18n.lang], false, false, $.proxy(this.closeReminderModal, this, callback));
			this.playlist.play();
		}

		TrackingAirplanes.prototype.closeReminderModal = function (callback) {
			var tl = new TimelineMax();
			tl.to($("#reminder"), 0.5, {
				autoAlpha: 0
			});

			if (typeof callback == "function") {
				callback();
			}
		}

		TrackingAirplanes.prototype.shouldReset = function () {

			if (BaseGame.prototype.shouldReset.call(this) == false) {
				return false;
			}

			if (this.currentScreen == 4) {
				return false;
			}

			return true;
		}

		TrackingAirplanes.prototype.reset = function (screenId) {

			// Super
			if (BaseGameLYVLC.prototype.reset.call(this, screenId) == false) {
				return false;
			}

			console.log("reset")

			// Stop audio (and their callbacks)
			this.playlist.clear();

			// Clear all timeouts
			this.clearAllTimeouts();

			this.closeReminderModal();

			this.stopAllInstructionVideos();

			this.instructionsSwiper.slideTo(0, 0);

			this.errorsCount = 0;
			this.selectedAirplane = false;
			// this.currentGameId = 0;
			this.currentEvent = false;
			this.currentEventStartTime = false;
			this.currentEventData = false;
			this.currentFeedback = false;
			this.totalEvents = false;

			$("#grid .slot").removeClass("empty error blue red green previous");
		}

		// Expose TrackingAirplanes
		window.TrackingAirplanes = TrackingAirplanes;
	}
)
(jQuery, Promise);
